import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { t } from '~/utils/narration';

export default function KycButton({ step, onContinue }) {
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [countdown, setCountdown] = useState(7);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown > 1) {
          return prevCountdown - 1;
        } else {
          clearInterval(timer);
          setBtnDisabled(false); // Enable the button after countdown
          return 0;
        }
      });
    }, 1000); // Update every 1 second

    return () => clearInterval(timer); // Clean up on unmount
  }, []);

  return (
    <Button
      variant="contained"
      disabled={btnDisabled}
      fullWidth
      onClick={onContinue}
      size="large"
      sx={{ py: 1.5 }}
    >
      {btnDisabled
        ? t({ en: `Getting ready in ${countdown}s`, hi: `${countdown} सेकंड में तैयार हो रहा है` })
        : step === 0
          ? t({ en: 'Ready to start KYC', hi: 'केवाईसी शुरू करने के लिए तैयार' })
          : t({ en: 'Continue to next step', hi: 'अगले स्टेप पर जाएँ' })}
    </Button>
  );
}